<div class="order-confirmation-ledger">
  <form [formGroup]="orderConfirmationLedgerForm" (ngSubmit)="submitForm()" class="m-5 pt-4">
    <div class="font-sm-size font-text-bold mb-1 text-uppercase text-muted">Search by order or PO number</div>
    <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
      <div class="form-group mt-3 col-lg-4 pl-0 float-left mb-3 p-res-0">
        <input type="text" class="form-control w-100" placeholder="Order #" formControlName="salesOrderNumber" />
        <span class="highlight"></span>
        <label class="text-muted">Order #</label>
      </div>
      <div class="form-group mt-3 col-lg-4 pl-0 float-left mb-3 p-res-0">
        <input type="text" class="form-control w-100" placeholder="PO #" formControlName="purchaseOrderNumber" />
        <span class="highlight"></span>
        <label class="text-muted">PO #</label>
      </div>
      <div class="col-lg-4 mt-3 d-flex">
        <button type="submit" [disabled]="isSearchDisabled" class="btn btn-primary mr-3">Search</button>
        <button class="btn btn-outline-primary" type="button" (click)="resetForm()">Reset</button>
      </div>
    </div>
  </form>
  @let orderHistoryResult = orderHistoryResult$ | async; @if(orderHistoryResult && orderHistoryResult.length > 0) {
   @let paginate = paginate$ | async;
  <div class="ml-5 mr-5">
    <div class="col-lg-12 d-flex justify-content-between align-items-center pr-0 pl-0 pb-2">
      <h4 class="col-lg-6 font-text-bold text-muted pl-0 mb-0">YOUR ORDERS</h4>
      <span class="col-lg-6 font-text-bold text-muted text-right mb-0 pr-0 font-sm-size">{{paginate.totalResults}} Order(s)</span>
    </div>
    <div class="orders-list">
      @for(order of orderHistoryResult; track order.code) {
      <div class="order-item" [ngClass]="order.code === selectedOrderDetails?.code ? 'active' : ''">
        <div class="row" (click)="loadSpecificOrderDetails(order?.code)">
          <div class="col-lg-2">
            <div class="font-xs-size text-muted"><span>ORDER #</span></div>
            <div class="font-sm-size font-text-600">{{ order.code }}</div>
          </div>
          <div class="col-lg-2">
            <div class="font-xs-size text-muted"><span>PO #</span></div>
            <div class="font-sm-size font-text-600">{{ order.purchaseOrderNumber }}</div>
          </div>
          <div class="col-lg-2">
            <div class="font-xs-size text-muted"><span>ORDER DATE</span></div>
            <div class="font-sm-size font-text-600">{{ order.creationDate }}</div>
          </div>
          <div class="col-lg-2">
            <div class="font-xs-size text-muted"><span>LINES</span></div>
            <div class="font-sm-size font-text-600">{{ order.lineItemCount }}</div>
          </div>
          <div class="col-lg-4 ml-auto text-right">
          <img
              src="/images/chevron-right.svg"
              class="chevron"
              alt=""
              [class.active]="selectedOrderDetails?.code === order.code"
            />
          </div>
        </div>
        @if(selectedOrderDetails && selectedOrderDetails.code === order.code) {
        <div class="selected-order-detail">
          <div class="ship-info-list">
            <div class="fully-shipped shipped-card-info">
              <div class="font-xs-size">FULLY SHIPPED</div>
              <div class="font-text-bold">{{getFullyShippedCount(selectedOrderDetails)}} of {{ order.lineItemCount }}</div>
            </div>

            <div class="partially-shipped shipped-card-info">
              <div class="font-xs-size">PARTIALLY SHIPPED</div>
              <div class="font-text-bold">{{getPartiallyShippedCount(selectedOrderDetails)}} of {{ order.lineItemCount }}</div>
            </div>

            <div class="not-shipped shipped-card-info">
              <div class="font-xs-size">NOT SHIPPED</div>
              <div class="font-text-bold">{{getNotShippedCount(selectedOrderDetails)}} of {{ order.lineItemCount }}</div>
            </div>

            <div class="customer-cancelled shipped-card-info">
              <div class="font-xs-size">CUSTOMER CANCELLED</div>
              <div class="font-text-bold">{{getCancelledCount(selectedOrderDetails)}} of {{ order.lineItemCount }}</div>
            </div>
          </div>
          @for(lineItem of selectedOrderDetails?.orderEntries; track lineItem?.entryNumber) {
          <div class="line-item">
            <div class="d-flex">
              <div class="font-text-bold mr-3 font-sm-size">
                <span>{{ lineItem?.product?.code }}</span>
              </div>
              <div class="font-sm-size">{{ lineItem?.product?.name }}</div>
              <div class="ml-auto font-text-bold text-muted font-xs-size">
                <span>{{ getLineItemStatus(lineItem) }}</span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-lg-2">
                <div class="font-xs-size text-muted">ORDERED</div>
                <div class="font-text-bold">{{ lineItem?.quantity }} {{ lineItem?.uom }}</div>
              </div>
              <div class="col-lg-2">
                <div class="font-xs-size text-muted">SHIPPED</div>
                <div class="font-text-bold">{{ lineItem?.quantity - lineItem?.openQuantity }} {{ lineItem?.uom }}</div>
              </div>
              <div class="col-lg-2">
                <div class="font-xs-size text-muted">OPEN</div>
                <div class="font-text-bold">{{ lineItem?.openQuantity }} {{ lineItem?.uom }}</div>
              </div>
            </div>
          </div>
          }
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-xs-size text-muted">{{ selectedOrderDetails?.orderEntries?.length }} line item(s) on this order.</div>

            <button
              type="button"
              class="btn btn-primary"
              [disabled]="downloadProgress"
              (click)="downloadOrder(selectedOrderDetails?.code)"
            >
              {{ 'invoiceResult.download' | cxTranslate }}
              <i class="fas fa-download" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        }
      </div>
      }
    </div>
    <div class=" w-100 mt-3 text-align-center">
  @if (paginate.currentPage < paginate.totalPages - 1) {
    <div
      (click)="loadMore(paginate.currentPage)" class="btn btn-loadmore mt-0 mr-3">
      {{ 'orderHistoryResult.showMore' | cxTranslate }}
    </div>
  }
</div>
  </div>
  } @if (orderHistoryResult && orderHistoryResult.length < 1 && !(isLoader$ | async)) {
  <div class="alert-info p-5 rounded m-5">
    {{ 'orderHistoryResult.nodataMsg' | cxTranslate }}
  </div>
  }
</div>
